import { replaceValueForPhone } from '@r1-frontend/ui-react/components/inputSimple/decorators/helpers/phoneDecorator';

interface IFormatValueForPhoneWithSpaces {
    value: string,
    isMasked?: boolean,
    label?: string,
}

export const formatValueForPhoneWithSpaces = ({ value, isMasked, label = '' }: IFormatValueForPhoneWithSpaces) => {
    if (isMasked) {
        return value.replace(/(\+7|7|8)(\d{3})(\*{3})(\*+\d{1})(\d{2})/, `${label} $2 $3 $4 $5`);
    }
    const digitsOnly = replaceValueForPhone(value);
    return (
        `${label} ${digitsOnly.slice(1, 4)} ${digitsOnly.slice(4, 7)} ${digitsOnly.slice(7, 9)} ${digitsOnly.slice(9)}`
    );
};
